var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgEnGBreact = function SvgEnGBreact(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#41479B",
    d: "M23.55 21H.45Q0 21 0 20.55V3.45Q0 3 .45 3h23.1q.45 0 .45.45v17.1q0 .45-.45.45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M24 3.45V3h-4.5L15 7.5V3H9v4.5L4.5 3H.45Q0 3 0 3.45V4.5L4.5 9H0v6h4.5L0 19.5v1.05q0 .45.45.45H4.5L9 16.5V21h6v-6l6 6h3v-1.5L19.5 15H24V9h-4.5L24 4.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4B55",
    d: "M24 10.5H13.5V3h-3v7.5H0v3h10.5V21h3v-7.5H24z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4B55",
    d: "M19.5 21 15 16.5V15h1.5l4.5 4.5 1.5 1.5zM1.5 3l6 6H9V7.5L4.5 3zM1.5 21l6-6h-3L0 19.5V21zM22.5 3l-6 6h3L24 4.5V3z"
  })));
};
export default SvgEnGBreact;